import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { CMDSpInitChat, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';
import { chatSliceActions } from '@/modules/main/slice/chat';

export class CMDSpInitChatHandler extends AbstractHandler {
    _command: CMDSpInitChat;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDSpInitChat;
    }

    handle(dispatch: Dispatch<AnyAction>): void {
        const cmd = this._command;
        dispatch(
            chatSliceActions.updateData({
                trial: cmd.Trial ? true : false,
                internalTestMode: cmd.internalTestMode ? true : false,
                lobbyChatEnable: cmd.ChatEnable ? true : false,
                HideMessage: cmd.HideMessage ? true : false,
            })
        );
    }
}
